import WhyLakme from "../images/why-lakme.jpg";
import "../css/animate.css"
import Add from "../images/add.png";
import Edit from "../images/edit.png";
import Delete from "../images/delete.png";
import lock from "../images/lock.png";
import { Component } from "react";
import $ from "jquery";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { editorState, convertToRaw, ContentState, convertFromHTML, Modifier, EditorState } from 'draft-js';
import draftToHtml from "draftjs-to-html";
import Parser from "html-react-parser";
import { saveItCareerForm } from "../service";
import AWS from "aws-sdk";
import { getawscredentials } from "../service";
var s3;


class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditorChooseActive: "0",
      benifitsArray: [],
      benifitsContentDataSubId: "",
      ["editorState_benifits"]: "",
      benifitsArrayList: [],
      benifitsdescriptionstate: "",
      imageState: "",
      imageNameState: "",
      benifitstextstate: "",
      imageFullFilePath: "",
      file: "",
      imageFileName: "",
      serviceImage: "",
      s3BucketMainFolder: "",
      accessKey: "",
      secretKey: "",
      s3bucket: "",
    }
  }


  componentDidMount() {
    this.getAwsDetails();

    this.setState({
      benifitContentId: this.props.benifitsArray[0].contentDataId,
      benifitsArrayList: this.props.benifitsArray[0].listing,

    });
    if (this.props.benifitsArray[0].listing.length > 0) {
      this.setState({
        benifitstextstate: this.props.benifitsArray[0].listing[0].contentDataSubTitle,
        benifitsdescriptionstate: this.props.benifitsArray[0].listing[0].contentDataSubSubtitle,
        imageState: this.props.benifitsArray[0].listing[0].image,
        imageNameState: this.props.benifitsArray[0].listing[0].imageName
      });
    }
  }


  getAwsDetails() {
    let postData = {
      "functionName": "awsCredentials",
    };
    getawscredentials(postData).then((data) => {
      console.log("decoded", data);
      if (data.data.success === "1") {
        var decoded = data.data.result.s3Details;
        localStorage.setItem("S3BucketMainFolder", decoded.mainFolder);
        localStorage.setItem("Bucket", decoded.s3bucket);

        AWS.config.update({
          accessKeyId: decoded.accessKey,
          secretAccessKey: decoded.secretKey,
          region: "ap-south-1",
        });
        var bucketParams = {
          Bucket: decoded.s3bucket,
        };
        s3 = new AWS.S3({ apiVersion: "2006-03-01", params: bucketParams });

        this.setState(
          {
            s3BucketMainFolder: decoded.mainFolder,
            accessKey: decoded.accessKey,
            secretKey: decoded.secretKey,
            s3bucket: decoded.s3bucket,
          },
          () => {
            // resolve(true);
          }
        );
      } else {
        console.log("error:home:getAwsDetails:", data.errorMessage);
      }
    });
    // });
  }

  onEditorStateChange = (e, mode) => {
    this.setState({
      [mode]: e,
    });
  };
  handleBeforeInput = (e, mode) => {
    const currentContent = this.state[mode].getCurrentContent();
    const currentContentLength = currentContent.getPlainText("").length;
    if (currentContentLength >= 2500) {
      return "handled";
    }
  };
  save() {
    var flag = true
    if ($("#benefitinputtxt").val() === '') {
      $("#benefitinputtxt").focus()
      alert("Enter Text")
      return false;
    }
    if (this.state["editorState_benifits"] === '') {
      alert("Enter Description")
      return false;
    }
    if (!this.state.imageFileName && !this.state.imageNameState) {
      alert("Upload Image")
      return false;
    }
    if (flag == true) {
      let contentDataId = this.state.benifitContentId
      let benefitsText = $("#benefitinputtxt").val()
      let benefitsAlt = $("#benefit_altinput").val()
      let benifitsdescription = draftToHtml(
        convertToRaw(this.state["editorState_benifits"].getCurrentContent())
      );
      let imageName =
        this.state.imageFileName !== ""
          ? this.state.imageFileName
          : this.state.imageNameState;

      this.saveAbout(
        contentDataId,
        benifitsdescription,
        benefitsText,
        benefitsAlt,
        imageName,
      );
    }
  }
  saveAbout(
    contentDataId, benifitsdescription, benefitsText, benefitsAlt, imageName,
  ) {
    const postData = {
      functionName: "saveContentDataSub",
      contentDataId: contentDataId,
      contentDataSubId: this.props.benifitsArray[0].listing.length > 0 ? this.props.benifitsArray[0].listing[0].contentDataSubId : "",
      contentDataSubDescription: "",
      contentDataSubTitle: benefitsText,
      siteId: "",
      contentDataSubIsApproved: "0",
      image: imageName,
      userRole: "SuperAdmin",
      oldImage: "",
      isSaveDraft: "0",
      contentDataSubSortOrder: "",
      pageId: "1",
      altText: benefitsAlt,
      h3Tag: "",
      contentDataSubSubtitle: benifitsdescription,
    };
    if (this.state.imageFileName.length > 0) {
      this.saveImageUpload();
    }
    console.log("postDataaaa benefits", postData);
    console.log("imageName benefits = ", this.state.imageFileName);
    saveItCareerForm(postData).then((data) => {
      console.log("hhhhhh.....", data);
      if (data.data.success == 1) {
        this.props.getData()
        this.cancelbenefitWrapper();
      }
    });
  }

  editbenefitSec() {
    $(".whychooseMaac").addClass("editActive");
    this.setState({ isEditorChooseActive: "1" });
    if (this.props.benifitsArray[0].listing.length > 0) {
      this.setState({
        ["editorState_benifits"]: EditorState.createWithContent(
          ContentState.createFromBlockArray(
            convertFromHTML(this.props.benifitsArray[0].listing[0].contentDataSubSubtitle)
          )
        )
      });
      $("#benefitinputtxt").val(this.props.benifitsArray[0].listing[0].contentDataSubTitle);
      $("#benefit_altinput").val(this.props.benifitsArray[0].listing[0].altText);
    }
  }

  deletebenefitsec(mode) {
    if (mode === "delete") {
      const postData = {
        functionName: "delete",
        contentDataSubId: this.props.benifitsArray[0].listing[0].contentDataSubId,
      };
      if (window.confirm("Do you want to delete?")) {
        saveItCareerForm(postData).then((data) => {
          if (data.data.success == 1) {
            this.props.getData();
            window.location.reload();
          }
        });
      } else {
        return false;
      }
    }
  }


  benefitsImageLoad(e) {
    var fileObj = e.target.files[0];
    let str = fileObj.name;
    var last = str.substring(str.lastIndexOf("/") + 1, str.length);
    let S3BucketMainFolder =
      localStorage.getItem("S3BucketMainFolder");
    let fileName = "aic_" + last;
    let reader = new File([fileObj], fileName, {
      type: "image/jpeg",
      lastModified: Date.now(),
    });
    let fullFilePath = S3BucketMainFolder + "/" + fileName;
    this.setState({
      imageFullFilePath: fullFilePath,
      file: reader,
      imageFileName: fileName,
      serviceImage: window.URL.createObjectURL(e.target.files[0]),
    });
  }

  saveImageUpload() {
    console.log("saveimageupload = ", this.state.imageFullFilePath);
    console.log("saveimageupload file = ", this.state.file);
    s3.upload(
      {
        Key: this.state.imageFullFilePath,
        Body: this.state.file,
        ACL: "public-read",
      },
      (err, data) => {
        console.log("err", err);
        if (err) {
          alert("There was an error uploading your photo: ", err.message);
          return null;
        } else {
        }
      }
    );
  }


  Addbenefits() {
    $(".whychooseMaac").addClass("editActive");
    this.setState({ isEditorChooseActive: "1" });
  }
  cancelbenefitWrapper() {
    $(".whychooseMaac").removeClass("editActive");
    this.setState({ isEditorChooseActive: "0" });
  }
  render() {
    return (
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 10" preserveAspectRatio="none">
          <polygon points="100 0 100 10 0 10"></polygon>
        </svg>
        <section className="padding bglight whychooseMaac">
          {(localStorage.getItem('role') === "SuperAdmin" || localStorage.getItem('role') === "Admin") &&
            <>
              <div className="adminIconMain">
                {this.props.benifitsArray[0].listing.length == "0" ?
                  <span
                    className="editIcon addButton"
                    onClick={(e) => {
                      this.Addbenefits();
                    }}
                  >
                    <img src={Add} />
                  </span>
                  :
                  <>
                    <span
                      class="editIcon editButton"
                      onClick={(e) => {
                        this.editbenefitSec();
                      }}
                    >
                      <img src={Edit} />
                    </span>
                    {/* <span class="editIcon lockButton"><img src={lock} /></span> */}
                    <span class="editIcon DeleteIcon" onClick={() => this.deletebenefitsec("delete")}>
                      <img src={Delete} />
                    </span>
                  </>
                }
              </div>
              {/* <div className="adminIconLeft">
            <div className="approveButton">Approve</div>
            <div class="draftSpan"> Draft </div>
            <div className="rejectSection">
              <div class="rejectButton"> Reject </div>
              <textarea
                className="rejectComment"
                placeholder="Enter Reason"
              ></textarea>
            </div>
            <div className="rejectSection">
              <div class="rejectButton"> Rejected </div>
              <div className="rejectCommentText">Reason :</div>
            </div>
          </div> */}
            </>
          }
          <div className="container text-left benefits_ulwrapr">
            <div className="row">

              <div className="col-xs-12 col-md-7 col-lg-6">
                <h2 className="text-capitalize wow fadeIn bottom20">
                  {this.props.benifitsArray[0].listing.length ?
                    this.props.benifitsArray[0].listing[0].contentDataSubTitle
                    : ""}
                  {/* With Lakmé Academy powered by Aptech, You Will Benefit From: */}
                </h2>

                <div className="abtImgMobResponsive">
                  <img src=
                  {this.props.benifitsArray[0].listing.length ?
                    this.props.benifitsArray[0].listing[0].image
                    : ""}
                  className="img-responsive" 
                  alt= {this.props.benifitsArray[0].listing.length ?
                    this.props.benifitsArray[0].listing[0].altText
                    : ""} />{" "}
                </div>
                
                <input type="text" placeholder="Enter Title" class="editInput" id="benefitinputtxt" />
                {/* <div className="col-xs-12 abotImg-mob wow slideInRight">
                  <img src={WhyLakme} className="img-fluid imgLakme" />{" "}
                  <div class="imageEditList">
                    <span class="upload-label-txt">jpeg/png less than 1 MB and 546*448</span>
                    <span class="fileUpload">
                      <input class="fileUploadCourse" type="file" id="fileUploadwhoweare" onChange={(e) => this.contactUsBannerImageLoad(e)} />
                      <label for="fileUploadwhoweare">Upload media</label>
                    </span>
                    <img class="imgPreview" width="200" src={WhyLakme}></img>
                  </div>
                </div> */}


                <div className="starList wow slideInLeft">
                  {this.props.benifitsArray[0].listing.length ?
                    Parser(this.props.benifitsArray[0].listing[0].contentDataSubSubtitle)
                    : ""}
                </div>
                {
                  this.state.isEditorChooseActive === "1" ?
                    <Editor
                      editorState={this.state["editorState_benifits"]}
                      id={"editorState_benifits"}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      className="editTextInput"
                      editorClassName="editorClassName"
                      onEditorStateChange={(e) =>
                        this.onEditorStateChange(e, "editorState_benifits")
                      }
                      handleBeforeInput={(e) =>
                        this.handleBeforeInput(e, "editorState_benifits")
                      }
                      handlePastedText={(input) => {
                        const inputLength = this.state["editorState_benifits"]
                          .getCurrentContent()
                          .getPlainText().length;
                        let remainingLength = 2500 - inputLength;
                        if (input.length + inputLength > 2500) {
                          const newContent = Modifier.replaceText(
                            this.state["editorState_benifits"].getCurrentContent(),
                            this.state["editorState_benifits"].getSelection(),
                            input.slice(0, remainingLength)
                          );
                          this.onEditorStateChange(
                            EditorState.push(
                              this.state["editorState_benifits"],
                              newContent,
                              "insert-characters"
                            ),
                            "editorState_benifits"
                          );
                          return true;
                        } else {
                          return false;
                        }
                      }}
                      toolbar={{
                        options: ["inline", "link", "list"],
                        inline: {
                          options: [
                            "bold",
                            "italic",
                            "underline",
                            "superscript",
                            "subscript",
                          ],
                        },
                        link: {
                          options: ["link"],
                        },
                        list: {
                          options: ["unordered"],
                        },
                      }}
                    />


                    : ""}
                <div className="editPanelButton">
                  {/* <span className="saveButton saveDraft">Save Draft</span> */}
                  <span className="saveButton" onClick={() => { this.save() }}>Submit</span>
                  <span className="cancelButton" onClick={(e) => { this.cancelbenefitWrapper() }}>Cancel</span>
                </div>
              </div>
              <div className="col-md-5 col-lg-6 wow slideInRight abotImg-web">
                <img src=
                  {this.props.benifitsArray[0].listing.length ?
                    this.props.benifitsArray[0].listing[0].image
                    : ""}
                  className="img-responsive" 
                  alt= {this.props.benifitsArray[0].listing.length ?
                    this.props.benifitsArray[0].listing[0].altText
                    : ""} />{" "}
                <div class="imageEditList imageEditList-minheight">
                  <span class="upload-label-txt">jpeg/png less than 1 MB and 546*448</span>
                  <span class="fileUpload">
                    <input class="fileUploadCourse" type="file" id="fileUploadbenefits" onChange={(e) => this.benefitsImageLoad(e)} />
                    <label for="fileUploadbenefits">Upload media</label>
                  </span>
                  {/* <div className="text-center mb-3">
                        <img src={WhyLakme} alt="WhyLakme" style={{width:"60%"}} />
                      </div> */}
                  {this.state.serviceImage ?
                    <div className="text-center mb-3">
                      <img src={this.state.serviceImage} style={{ width: "15%" }} />
                    </div>
                    : this.props.benifitsArray[0].listing.length ? <div className="text-center mb-3">
                      <img src={this.props.benifitsArray[0].listing[0].image} style={{ width: "15%" }} />
                    </div> : ""}
                    <input type="text" className="editInput" id="benefit_altinput"  placeholder="Enter alt Text" style={{width:"353px"}} />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default About;
